module.exports = __webpack_public_path__ + "img/performant.9b8edc6a.png";